export default "__VITE_ASSET__BmV0a2LB__"